import React from "react"
import { Button } from "react-bootstrap"
import FontAwesome from "react-fontawesome"

export default function ButtonUpdate({ running, onClick }) {

  return (
    <Button onClick={ onClick }
      className="w-100" bsStyle="info" disabled={ running }>
      { running
      ? <FontAwesome name="spinner" className="animate-spin mr-3" />
      : <FontAwesome name='pencil' /> } Edit
    </Button>
  )
}


// WEBPACK FOOTER //
// ./src/components/Accounting/ButtonUpdate.js